setTimeout(() => {
    if(BSS_B2B){
        const dcBox = document.querySelector('.bss-b2b-discount-code-wrapper.bss-config-header');
        const position = document.querySelector('.wt-cart__footer__body');
        if(dcBox && position){
            position.before(dcBox)
        }


        //mini-cart
        const ele = document.querySelector('cart-drawer');
        if(ele){
            const observer = new MutationObserver((MutationList) => {
                console.log(4);
                BSS_B2B.dc.initFunction();
            })
            observer.observe(ele, {attributes: true})
        }

        //fix link
        const linkBtn = document.querySelector('.wt-page-nav-mega__sublist__item a[href="/pages/intercompany-program"]');
        if(linkBtn){
            linkBtn.setAttribute('href', 'https://magcharm.com/pages/intercompany-frequently-asked-questions')
        }
    }
}, 300)